<template>
	<div v-if="!user.isAuth" class="form-group form-group-inline">
		<form action="/login" method="POST" v-on:submit.prevent="login">
			<input type="text" placeholder="Email" v-model="form.email">
			<input type="password" placeholder="Пароль" v-model="form.password">
			<button type="submit" class="btn btn-primary">Войти</button>
		</form>
	</div>
</template>

<script>
	export default {
		props: ['user'],
		template: '#login-form',

		data: function () {
			return {
				form: {
					email: null,
					password: null,
				},
			}
		},

		methods: {
			login: function () {
				this.$root.$emit('login', {
					'email': this.form.email,
					'password': this.form.password
				});
				this.password = '';
			}
		}
	}
</script>
